import { useState, useCallback, useEffect } from 'react';
import { useSelector } from "react-redux";
import { cloneDeep, isNil, size, orderBy } from "lodash";

const formatObj = { country: {}, city: {} }
const formatArr = { country: [], city: [] }

const useCountry = () => {
  const { supportSetting: { countryTimezoneList } } = useSelector(store => store);

  const [countryList, setCountryList] = useState(cloneDeep(formatArr));
  const [selectedCountry, setSelectedCountry] = useState(cloneDeep(formatObj));

  const init = () => {
    const copyList = cloneDeep(countryTimezoneList);
    const selected = copyList[0]
    selected.isActive = true
    selected.cities[0].isActive = true

    const tmpList = {}
    tmpList.country = copyList
    tmpList.city = selected.cities

    const tmpSelected = {}
    tmpSelected.country = selected
    tmpSelected.city = selected.cities[0]
    setCountryList(tmpList)
    setSelectedCountry(tmpSelected)
  }

  const findCity = (city, cityList) => {
    const key = city?.city || city?.title
    let targetCity = null
    for (const data of cityList) {
      if (data.city === key) {
        data.isActive = true
        targetCity = data
      } else {
        delete data.isActive
      }
    }
    if (isNil(targetCity)) {
      cityList[0].isActive = true
      targetCity = cityList[0]
    }
    return { targetCity, cityList }
  }

  const changeCountry = (target) => {
    const tmpSelected = cloneDeep(selectedCountry)
    const copyList = cloneDeep(countryTimezoneList);
    const tmpList = {}

    for (const data of copyList) {
      if (data.title === target.title) {
        data.isActive = true
        tmpSelected.country = data

        data.cities[0].isActive = true
        tmpSelected.city = data.cities[0]
        tmpList.city = data.cities
        break
      }
    }
    tmpList.country = copyList
    setCountryList(tmpList)
    setSelectedCountry(tmpSelected)
  }

  const changeCity = (target) => {
    const copyList = cloneDeep(countryList.city);
    const { targetCity, cityList } = findCity(target, copyList)
    setSelectedCountry({ ...selectedCountry, city: targetCity })
    setCountryList({ ...countryList, city: cityList })
  }

  const setDefaultCountry = ({ country, city }) => {
    // *** format { country: {title: ''}, city: {title: ''} }
    // 1. country.title is undefined = reset to first.
    // 2. city.title is undefined = set first city in country.
    if (isNil(country?.title)) {
      init()
      return
    }

    const tmpSelected = cloneDeep(selectedCountry)
    const copy = cloneDeep(countryTimezoneList);
    for (const countryData of copy) {
      if (countryData.title === country.title) {
        countryData.isActive = true
        tmpSelected.country = countryData
        break
      }
    }

    const { targetCity, cityList } = findCity(city, tmpSelected.country.cities)
    tmpSelected.city = targetCity
    const tmpList = {
      country: copy,
      city: cityList
    }

    setCountryList(tmpList)
    setSelectedCountry(tmpSelected)
  }

  useEffect(() => {
    if (!isNil(countryTimezoneList)) init()
  }, [countryTimezoneList]);

  return { countryList, selectedCountry, changeCountry, changeCity, setDefaultCountry };
}

export default useCountry;